import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { PrincipalWebService } from "@sinequa/core/web-services";
import { BehaviorSubject } from "rxjs";
import { environment } from "../environments/environment";

@Injectable({
    providedIn: "root"
})
export class EsWebService {
    sessionId:any;
	pridKey:any = 'name';
    url:String = "https://search-dev.astrazeneca.com"
    public principleFetched:BehaviorSubject<any>;
    public sessionFetched:BehaviorSubject<any>;
	public reAsk:BehaviorSubject<any>;
    SamlFetched:boolean = false;
    public userInfo: BehaviorSubject<any>;
    public totalCount: BehaviorSubject<any>;
    constructor(
        private http : HttpClient,
        public principalService:PrincipalWebService
    ) {
        this.userInfo = new BehaviorSubject<any>({});
        this.totalCount = new BehaviorSubject<any>(undefined);
		this.reAsk = new BehaviorSubject<any>('');
        this.sessionFetched= new BehaviorSubject<any>({});
        this.principleFetched = new BehaviorSubject<any>({});
        
    }

    
    getUser(){
        this.http.post(environment.SAML_url + '/test', { token: localStorage.getItem('token') })
					.subscribe((response: any) => {
						if (response) {
                            this.SamlFetched= true
							localStorage.setItem("SAML", response['SAML_token']);
                            sessionStorage.setItem('idle_session_id',response['idle_session_id']);
                            console.log("samlfetched")
                            this.setValue(response)
						} else {
                            this.SamlFetched= true
							localStorage.removeItem('SAML');
							localStorage.removeItem('token');
							this.login();
						}
					}, (err: any) => {
                        sessionStorage.removeItem('idle_session_id')
						localStorage.removeItem('SAML');
						localStorage.removeItem('token');
					})
    }

    getCount(){
       return this.http.post(environment.api_url + '/xrest?call=searchconfig', { method: "dev.plugin", Plugin : "InsightsVaultRecordCount" })
					
    }

    login(){
        location.href = environment.SAML_url+"/login";
    }
    public get currentUserValue(): any {
        return this.userInfo?.value;
      }

    getValue():any {
        return this.userInfo.value;
    }
    getPrincipleValue():any {
        return this.principleFetched.value;
    }
    getSessionValue():any {
        return this.sessionFetched.value;
    }
    setPrincipleValue(newValue):void {
        this.principleFetched.next(newValue);
    }
    setValue(newValue): void {
        this.userInfo.next(newValue);
    }
     
}

